import React from 'react';
import { DataGrid } from '../../../../../components/DataGrid/DataGrid';
import { localText } from '../../../../../langs/fa/data-grid';
import NoDrivers from './NoDrivers';
import { useHistory } from 'react-router-dom';
import { __ } from '../../../../../utils/i18n';
import CallUser from '../../../../../components/User/CallUser';
import Avatar from '../../../../../components/User/UserAvatar';
import { useQuery } from 'react-query';
import { useDriversList } from '../../../../../useStores/useDriversStore';
import { useMainStore } from 'useStores/useMainStore';
import { useSearchParams } from 'hooks/useSearchParams';
import { useLocation } from 'react-router-dom';
import { getAllDriversPaginated } from 'useReactQueries/useDrivers';

const DriversList = () => {
  const location = useLocation();
  const limit = useMainStore((state) => state.limit);
  const totalPages = useDriversList((state) => state.totalPages);
  const setTotalPages = useDriversList((state) => state.setTotalPages);
  const [params, setParams] = useSearchParams();
  const history = useHistory();
  const columns = [
    // { field: 'firstName', headerName: 'نام', flex: 1 },
    // { field: 'lastName', headerName: 'نام‌خانوادگی', flex: 1 },
    {
      field: 'name',
      headerName: 'نام',
      flex: 1,
      renderCell: ({ value }) => (
        <>{value ? <Avatar user={value} fullName /> : ''}</>
      ),
      onClick: (e) => e.stopPropagation(),
    },
    { field: 'nationalCode', headerName: 'کدملی', width: 130 },
    { field: 'smartcard', headerName: 'کدناوگان', width: 150 },
    { field: 'numberPlate', headerName: 'پلاک‌خودرو', width: 150 },
    {
      field: 'mobilePhone',
      renderCell: ({ value: mobilePhone }) => <CallUser tel={mobilePhone} />,
      headerName: 'موبایل',
      width: 150,
    },
    { field: 'status', headerName: 'وضعیت', width: 120 },
  ];

  const handlePageChange = (pageNum) => {
    setParams([{ name: 'page', value: pageNum }]);
  };

  const { data, isLoading } = useQuery(
    ['drivers', Number(params.get('page') || 1), limit, location.search],
    ({ signal }) => getAllDriversPaginated(signal, setTotalPages)
  );
  const drivers = data?.docs;

  const handleSelectOrder = ({ row, field }) => {
    const id = row.name._id;
    const fields = ['mobilePhone'];
    if (fields.includes(field)) return;
    history.push(`/protected/admin/users/driver/${id}`);
    // const [userId] = selection.rowIds;
    // const { user } = drivers.find((u) => u._id === userId);
    // const id = user?._id;
    // history.push(`/protected/admin/users/driver/${id}`);
  };

  return (
    <div style={{ width: '100%', height: 500 }}>
      <DataGrid
        rows={
          data?.docs?.map((u) => ({
            id: u._id,
            name: u?.user,
            nationalCode: u?.user?.nationalCode || '...',
            smartcard: u?.smartcard || '',
            numberPlate: u?.numberPlate
              ? `${u?.numberPlate?.firstCode || ''}-${
                  u?.numberPlate?.cityCode || ''
                }${u?.numberPlate?.alphabetCode || ''}${
                  u?.numberPlate?.secondCode || ''
                }`
              : '',
            mobilePhone: u?.user?.mobilePhone || '',
            status: u?.user?.status ? __(u.user.status) : 'نامشخص',
          })) || []
        }
        // disableSelectionOnClick
        // isRowSelectable={(params) => }
        columns={columns}
        totalPages={totalPages}
        pageNumber={Number(params.get('page')) || 1}
        footerPagination={true}
        localeText={localText}
        pageSize={limit}
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={isLoading}
        disableMultipleSelection
        density="compact"
        components={{
          noRowsOverlay: NoDrivers,
        }}
        onCellClick={handleSelectOrder}
        // onSelectionChange={handleSelectOrder}
      />
    </div>
  );
};

export default React.memo(DriversList);
